import { Directive, inject, signal } from '@angular/core'
import { MessagesService } from '@shared/services'
import { firstValueFrom } from 'rxjs'
import { ActivitiesService } from 'superlikers-microsites-api'

@Directive()
export class PhotoComponent {
  activitiesService = inject(ActivitiesService)
  messagesService = inject(MessagesService)

  imageUrl = signal<string | ArrayBuffer | null>(null)
  image = signal<File | null>(null)

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement
    const file = inputElement?.files?.[0]

    if (!file) return

    this.showImage(file)
    this.image.set(file)
  }

  showImage(file: File) {
    const reader = new FileReader()

    reader.onload = () => {
      this.imageUrl.set(reader.result)
    }

    reader.readAsDataURL(file)
  }

  async uploadPhoto(image: File, category: string) {
    try {
      const response$ = this.activitiesService.uploadPhoto({
        category,
        file: image
      })

      const response = await firstValueFrom(response$)
      if (response.state === 'error') throw new Error(response.message)

      return response.location
    } catch (err) {
      if (err instanceof Error) {
        this.messagesService.errorMessage(err.message)
      } else {
        this.messagesService.errorMessage('An unknown error occurred.')
      }

      return
    }
  }
}
